<template>
  <div>
    <v-row justify="center">
      <v-dialog
      v-model="dialog"
      fullscreen
      transition="dialog-bottom-transition"
      >
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-if="tipo_boton=='icono'" v-bind="attrs" v-on="on" @click="showChart()">
          mdi-finance
        </v-icon>
        <v-btn v-else class="mb-3" v-bind="attrs" v-on="on" @click="showChart()" color="primary" >CARGAR ÚLTIMO TRATAMIENTO</v-btn>
      </template>
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Detalles del Tratamiento</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click=" closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <!-- CABECERA DEL TRATAMIENTO -->
        <v-card ref="cabecera" class="elevation-0 ma-5">
          <v-row class="mr-2 ml-2">
            <v-col>ID del trabajo: <span class="texto_resaltado">{{ cabecera.id_trabajo }} </span></v-col>
            <v-col>Receta:  <span  class="texto_resaltado">{{ cabecera.nombre_receta }}</span></v-col>
            <v-col>Tipo de Tratamiento: <span class="texto_resaltado">{{ cabecera.nombre_tipo_tratamiento }}</span></v-col>
          </v-row>
          <v-row class="mr-2 ml-2">
            <v-col>Fecha Inicio:<span class="texto_resaltado">{{ cabecera.fecha_inicio }}</span></v-col>
            <v-col>Fecha Fin: <span class="texto_resaltado">{{ cabecera.fecha_fin }}</span></v-col>
            <v-col>Trabajador: <span class="texto_resaltado">{{ cabecera.trabajador }}</span></v-col>
            <v-col>Medición: 
              <span v-if="cabecera.estado == 1" class="texto_resaltado">
                Aereo
              </span>
              <span v-else class="texto_resaltado">Contacto</span>
          </v-col>
          </v-row>
        </v-card>

        <!-- GRAFICO -->
          <v-divider></v-divider>
          <v-row class="ma-5">
            <componente-grafica ref="graficoHistorico" :visible=" !loadingChart" :zonas="
            [
              detalles_con_pausas,
              datos_pv_1,
              datos_pv_2,
              datos_agua,
              datos_setpoint,
              datos_pv_1_contacto,
              datos_pv_2_contacto
            ]"
            :setpointMaximo="setpointMax"
            :medicion="cabecera.estado"
            class="full-height-component" ></componente-grafica>
          </v-row>
          
          <!-- Of-s configurados -->
          <v-container>
            <v-card>
              <v-card-title>
                OFS
                <v-spacer></v-spacer>
                <v-btn color="blue" dark @click="anadirOF">Añadir Of</v-btn>
              </v-card-title>
              <v-card-text>(Para editar hacer doble click en los valores)</v-card-text>
              <v-data-table 
                :items="items_ofs"
                :headers="headers_ofs"
                hide-default-footer
                disable-pagination
              >
                <template v-slot:item.of="{ item }">
                  <input-numero-editable :valor="item.of" @cambio="actualizarOf" :id="item.id"></input-numero-editable>
                </template>
                <template v-slot:item.cantidad="{ item }">
                  <input-numero-editable :valor="item.cantidad" @cambio="actualizarCantidad" :id="item.id"></input-numero-editable>
                </template>
                <template v-slot:item.colada="{ item }">
                  <input-numero-editable :valor="item.colada" @cambio="actualizarColada" :id="item.id"></input-numero-editable>
                </template>
                <template v-slot:item.actions="{ item }">
                  <!-- <v-icon small @click="editItem(item)">
                    mdi-pencil
                  </v-icon> -->
                  <v-icon small @click="deleteItem(item)">
                    mdi-delete
                  </v-icon>
                </template>
              </v-data-table>
            </v-card>
          </v-container>

          <!-- TABLA -->
          <v-divider></v-divider>
          <v-row class="mt-5ml-5 mr-5">
            <v-col>
              <v-data-table
              itemKey="id"
              :headers="headers"
              :items="datosTabla"
              :footer-props="{
                'items-per-page-options': [5, 10, 20, 30,40, 50],
                'items-per-page-text': 'Datos por página'
              }"
              sort-by="fecha"
              sort-asc
              >
              <template v-slot:no-results>
                <span>No hay datos para esta búsqueda</span>
            </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row >
          <v-col class="text-center">
            <v-btn large class="mb-10" @click="downloadCiclo()" rounded color="primary"><v-icon>mdi-download</v-icon> descargar</v-btn>
          </v-col>
        </v-row>
      </v-card>

      <!-- CARGANDO... -->
      <v-overlay class="text-center" 
      :opacity="0.8"
      :value="loadingChart"
      >
        <v-card-title>
        Cargando datos...
        </v-card-title>
        <v-progress-circular indeterminate size="64">
        </v-progress-circular>
      </v-overlay>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import html2canvas from 'html2canvas';
import 'jspdf-autotable';
import jsPDF from 'jspdf';
import ComponenteGrafica from "../ComponenteGrafica.vue";
import InputNumeroEditable from '@/components/modulos/InputNumeroEditable.vue'
import { mapActions } from "vuex";

export default {
  data() {
    return {
      dialog: false,
      datosCiclo: {},
      detalles_con_pausas: [],
      datos_pv_1: [],
      datos_pv_2: [],
      datos_pv_1_contacto: [],
      datos_pv_2_contacto: [],
      datos_agua: [],
      datos_setpoint: [],
      datosTabla:[],
      loadingChart: false,
      setpointMax:100,
      headers: this.cabecera.estado == 2 ? [
        { text: "Fecha", align: "center", value: "fecha" },
        { text: "Setpoint", align: "center", value: "setpoint" },
        { text: "PV Aereo Zona 1", align: "center", value: "pv_zona_1" },
        { text: "PV Aereo Zona 2", align: "center", value: "pv_zona_2" },
        { text: "PV Agua", align: "center", value: "pv_zona_agua" },
        { text: "PV Contacto Zona 1", align: "center", value: "pv_contacto_zona_1" },
        { text: "PV Contacto Zona 2", align: "center", value: "pv_contacto_zona_2" },
      ] : [
        { text: "Fecha", align: "center", value: "fecha" },
        { text: "Setpoint", align: "center", value: "setpoint" },
        { text: "PV Aereo Zona 1", align: "center", value: "pv_zona_1" },
        { text: "PV Aereo Zona 2", align: "center", value: "pv_zona_2" },
        { text: "PV Agua", align: "center", value: "pv_zona_agua" },
      ],
      items_ofs: [],
      headers_ofs: [
        // { text: "ID", value: "id" },
        { text: "Nº OF", value: "of" },
        { text: "Cantidad", value: "cantidad" },
        { text: "Colada", value: "colada" },
        { text: "Opciones", value: "actions" },
      ],
    };
  },
  props: {
    cabecera: Object,
    tipo_boton:String,
  },
  components:{
    ComponenteGrafica, InputNumeroEditable
  },
  methods: {
    ...mapActions("api", ["getTrabajo","getOfs","createOf","updateOfs","deleteOfs"]),
    padZero(number) {
      return number < 10 ? `0${number}` : number;
    },
    async showChart() {
      this.loadingChart = true;
      let datosTrabajo = await this.getTrabajo(this.cabecera.id_trabajo);
      this.datosCiclo = datosTrabajo.data;
      if (this.datosCiclo.valores) {
        console.log('ENTROO');
        console.log(this.datosCiclo);
        
        this.show();
      }
      this.loadingChart = false;
    },

    show() {
      this.datos_pv_1 = [];
      this.datos_pv_2 = [];
      this.datos_pv_1_contacto = [];
      this.datos_pv_2_contacto = [];
      this.datos_agua = [];
      this.datos_setpoint = [];
      this.datosCiclo.valores.forEach((e) => {
        let fecha = new Date(e.fecha_lectura);
        const hours = this.padZero(fecha.getHours());
        const minutes = this.padZero(fecha.getMinutes());
        // const seconds = this.padZero(fecha.getSeconds());

        let dia = fecha.getDate();
        let mes = fecha.getMonth()+1
        let year = fecha.getFullYear();
        let x = `${dia} - ${hours}:${minutes}`;
        let y = e.valor;
        let datoTabla = this.datosTabla.find(e => e.fecha == `${dia}/${mes}/${year} ${hours}:${minutes}`)
        if(!datoTabla){
          datoTabla = {fecha: `${dia}/${mes}/${year} ${hours}:${minutes}`}
          this.datosTabla.push(datoTabla)
        } 
        if (e.id_variable == 2) {
          const existeElemento = this.datos_pv_1.find(
            (elemento) => elemento.x === x
          );
          if (!existeElemento){
            this.datos_pv_1.push({ x, y });
            datoTabla.pv_zona_1 = y
          } 
        } else if (e.id_variable == 10) {
          const existeElemento = this.datos_agua.find(
            (elemento) => elemento.x === x
          );
          if (!existeElemento){
            this.datos_agua.push({ x, y });
            datoTabla.pv_zona_agua = y
          } 
        } else if (e.id_variable == 6) {
          const existeElemento = this.datos_pv_2.find(
            (elemento) => elemento.x === x
          );
          if (!existeElemento){
            this.datos_pv_2.push({ x, y });
            datoTabla.pv_zona_2 = y
          } 
        } else if (e.id_variable == 5) {
          const existeElemento = this.datos_setpoint.find(
            (elemento) => elemento.x === x
          );
          if (!existeElemento) {
            this.datos_setpoint.push({ x, y });
            datoTabla.setpoint = y
          }
        } else if (e.id_variable == 14) {
          const existeElemento = this.datos_pv_1_contacto.find(
            (elemento) => elemento.x === x
          );
          if (!existeElemento) {
            if(y < 1300){ //Quitamos de forma visual fallo de comunicación
              this.datos_pv_1_contacto.push({ x, y });
              datoTabla.pv_contacto_zona_1 = y
            }
          }
        } else if (e.id_variable == 15) {
          const existeElemento = this.datos_pv_2_contacto.find(
            (elemento) => elemento.x === x
          );
          if (!existeElemento) {
            if(y < 1300){ //Quitamos de forma visual fallo de comunicación
              this.datos_pv_2_contacto.push({ x, y });
              datoTabla.pv_contacto_zona_2 = y
            }
          }
        }
      });

      this.setpointMax = this.datos_setpoint.reduce((maximo, objeto) => {
        return objeto.y > maximo ? objeto.y : maximo;
      }, Number.NEGATIVE_INFINITY);

    },

    async downloadCiclo() {
      const grafico = this.$refs.graficoHistorico.$el;
      const canvasGrafico = await html2canvas(grafico);
      const imgData2 = canvasGrafico.toDataURL('image/png');
      
      const pdf = new jsPDF('p', 'mm', 'a4');
      
      // LA CABECERA
      const cabecera = [[`ID del trabajo: ${this.cabecera.id_trabajo?this.cabecera.id_trabajo:''}`, `Receta: ${this.cabecera.nombre_receta?this.cabecera.nombre_receta:''}`,`Tipo de Tratamiento: ${this.cabecera.nombre_tipo_tratamiento?this.cabecera.nombre_tipo_tratamiento:''}` ],
      [`Fecha Inicio: ${this.cabecera.fecha_inicio?this.cabecera.fecha_inicio:''}`, `Fecha Fin: ${this.cabecera.fecha_fin?this.cabecera.fecha_fin:''}`,`Trabajador: ${this.cabecera.trabajador?this.cabecera.trabajador:''}` ]]
      pdf.autoTable({
        body: cabecera,
        startY: 20, 
        theme:'plain',
        didDrawRow: (row) => {
          pdf.setFillColor('white'); 
          pdf.rect(row.table.body[0][0].x, row.y, row.table.width, row.height, 'F');
        },
      });
      // EL GRAFICO
      pdf.addImage(imgData2, 'PNG', 10, 70, 190, 100); 

      //Tabla OFS
      let head_ofs = this.headers_ofs.map(e => {return e.text})
      pdf.autoTable({
        head: [head_ofs],
        body: this.items_ofs.map(e => { return Object.values(e);}),
        startY: 200,
      });
      
      // LA TABLA
      let head = this.headers.map(e => {return e.text})
      console.log(this.datosTabla);
      let dataTercio = this.datosTabla.filter((_,index) => index % 3 === 0)
      pdf.autoTable({
        head: [head],
        body: dataTercio.map(e => { return Object.values(e);}),
        startY: 500,
      });
      let fecha_modificada = this.cabecera.fecha_inicio?this.cabecera.fecha_inicio.split(' ')[0]:null
      let nombre_receta_modificado = (this.cabecera.nombre_receta != undefined && this.cabecera.nombre_receta != null)?this.cabecera.nombre_receta.replace(' ','-'):`tratamiento_${this.cabecera.id_trabajo}`
      
      let file_name = this.getName()
      pdf.save(file_name);
    },
    getName(){
      let nombre = ''
      this.items_ofs.forEach(e => {
        nombre += e.colada
        nombre += '--'
      });
      return nombre
    },
    drawLineChart(pdf, data, config) {
      // Set the initial position for drawing
      let x = config.xStart;
      let y = config.yStart;

      // Set the line properties
      pdf.setLineWidth(config.lineWidth);
      pdf.setDrawColor(config.lineColor);

      // Move to the starting point
      pdf.moveTo(x, y);

      // Draw lines to connect the data points
      data.forEach(point => {
        console.log(point);
        pdf.lineTo(point.x, point.y);
      });

      // Stroke the path to actually draw the lines
      pdf.stroke();
    },

    closeDialog() {
      this.datos_pv_1 = [];
      this.datos_pv_2 = [];
      this.datos_agua = [];
      this.datos_setpoint = [];
      this.dialog = false;
    },
    async getOFS(){
      //Obtener of-s añadidas al ciclo, si es que las hay            
      let ofs = await this.getOfs(this.cabecera.id_trabajo)
      this.items_ofs = []
      console.log('ofs.data');
      console.log(ofs.data);
      ofs.data.forEach(element => {
        this.items_ofs.push(element)
      });
    },
    anadirOF(){
      console.log('Desarrollar anadir of id: ' + this.cabecera.id_trabajo);
      this.createOf(this.cabecera.id_trabajo).then( res => {  
        console.log(res)
        let nueva_of = {
          id: res.data[0].id_ofs,
          of: 'SIN RELLENAR',
          cantidad: 0,
          colada: 'SIN RELLENAR'
        }
        this.items_ofs.push(nueva_of)
      })
    },
    deleteItem(item){
      console.log('delete ' + item);
      this.items_ofs = this.items_ofs.filter(e => e.id != item.id)
      this.deleteOfs(item.id)
    },
    actualizarOf(payload){
      let item = this.items_ofs.filter(e => e.id == payload.id)
      item[0].of = payload.valor
      this.updateOfs(item[0])
    },
    actualizarCantidad(payload){
      let item = this.items_ofs.filter(e => e.id == payload.id)
      item[0].cantidad = payload.valor
      this.updateOfs(item[0])
    },
    actualizarColada(payload){
      let item = this.items_ofs.filter(e => e.id == payload.id)
      item[0].colada = payload.valor
      this.updateOfs(item[0])
    },
  },
  created() {
    this.getOFS()
  },
};
</script>
<style scoped>
.texto_resaltado{
  font-size:110%;
  font-weight:300
}
</style>